<template>
  <v-flex
    ma-2
    xs12
    v-if="showActionsSection"
    pr-2
  >
    <v-btn
      v-for="(item, index) in menuItemsFiltered"
      :key="index"
      block
      :color="item.color"
      class="ma-1"
      :disabled="disableActionButton(item.actionName)"
      :loading="showIsLoadingOnButton(item)"
      @click="menuActionClick(item)"
    >
      {{ actionButtonText(item.title, item.actionName) }}
      <v-layout slot="loader" align-center>
        <v-flex>
          <v-progress-circular
            :size="20"
            :width="2"
            indeterminate
            color="default"
          ></v-progress-circular>
        </v-flex>
        <v-flex class="text-xs-left">
          {{ actionButtonText(item.title, item.actionName) }}
        </v-flex>
      </v-layout>
    </v-btn>
  </v-flex>
</template>

<script>
import PurchaseOrderLineStatus from '@/models/purchaseOrderLineStatus';

export default {
  name: 'poLineItemsActions',
  computed: {
    menuItems() {
      return [
        {
          title: 'Submit',
          subjectName: 'SubmitAction',
          actionName: 'submit',
          data: PurchaseOrderLineStatus.UnderReview.key,
          color: 'primary',
          eventName: 'po-line-items-update-status',
          confirmationSettings: {
            headerText: this.$t('submitDisclaimerHeaderText'),
            bodyText: this.$t('submitDisclaimer'),
            confirmBtnText: this.$t('submitDisclaimerConfimBtnText'),
            enableNotes: true,
            isNotesRequired: false,
            confirmationColor: 'primary',
          },
        },
        {
          title: 'Approve',
          subjectName: 'ApproveAction',
          actionName: 'approve',
          data: PurchaseOrderLineStatus.Approved.key,
          color: 'success',
          eventName: 'po-line-items-update-status',
          confirmationSettings: {
            headerText: this.$t('approveDisclaimerHeaderText'),
            bodyText: this.$t('approveDisclaimer'),
            confirmBtnText: this.$t('approveDisclaimerConfimBtnText'),
            enableNotes: true,
            isNotesRequired: false,
            confirmationColor: 'success',
          },
        },
        {
          title: 'Reject',
          subjectName: 'RejectAction',
          actionName: 'reject',
          data: PurchaseOrderLineStatus.NotApproved.key,
          color: 'error',
          eventName: 'po-line-items-update-status',
          confirmationSettings: {
            headerText: this.$t('rejectDisclaimerHeaderText'),
            bodyText: this.$t('rejectDisclaimer'),
            confirmBtnText: this.$t('rejectDisclaimerConfimBtnText'),
            enableNotes: true,
            isNotesRequired: true,
            confirmationColor: 'error',
          },
        },
        {
          title: 'Report Issue',
          subjectName: 'ReportIssue',
          actionName: 'report',
          data: null,
          color: 'error',
          eventName: 'po-line-items-report-issue',
          confirmationSettings: {
            headerText: this.$t('reportIssueDisclaimerHeaderText'),
            bodyText: this.$t('reportIssueDisclaimer'),
            confirmBtnText: this.$t('reportIssueDisclaimerConfimBtnText'),
            enableNotes: true,
            isNotesRequired: true,
            confirmationColor: 'error',
          },
        },
        {
          title: 'Print Approval',
          subjectName: 'DownloadAction',
          actionName: 'download',
          data: null,
          color: 'grey lighten-2',
          eventName: 'po-line-items-download-approval',
          confirmationSettings: {
            headerText: this.$t('printApprovalDisclaimerHeaderText'),
            bodyText: this.$t('printApprovalDisclaimer'),
            confirmBtnText: this.$t('printApprovalDisclaimerConfimBtnText'),
            enableNotes: false,
            isNotesRequired: false,
            confirmationColor: 'primary',
          },
        },
      ];
    },
    menuItemsFiltered() {
      return this.menuItems
        .filter(mi => this.$isAllowed('view', mi.subjectName, {
          clients: this.poClients,
          isMyClient: this.isMyClient,
          isMyEmployeeClient: this.isMyEmployeeClient,
        }));
    },
    showActionsSection() {
      return this.menuItemsFiltered.length > 0;
    },
  },
  methods: {
    actionButtonText(title, actionName) {
      if (this.disableActionButton(actionName)) {
        return title;
      }

      return `${title} (${this.itemsFilteredByRestrictions(actionName).length} of ${this.groupedItemsLength})`;
    },
    menuActionClick(item) {
      this.$emit('menu-action-click', item);
    },
  },
  props: {
    poClients: Array,
    groupedItemsLength: Number,
    disableActionButton: Function,
    showIsLoadingOnButton: Function,
    itemsFilteredByRestrictions: Function,
    isMyClient: Boolean,
    isMyEmployeeClient: Boolean,
  },
};
</script>
